import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- entities
import Payout from 'PMT/entities/Payout';
import PayoutList from 'PMT/entities/PayoutList';

// -- components
import AbstractComponent from 'components/AbstractComponent';
import PayoutsTableView from './PayoutsTableView';

/**
 * @parent ReceiptPage
 */
export default class PayoutsView extends AbstractComponent {

  static propTypes = {
    payoutList: PropTypes.instanceOf(PayoutList).isRequired,
    currencyCode: PropTypes.string,
  };

  renderNoData(): Object {
    // no information to display

    return (
      <div className="payment_payins__no_data">
        <div className="col-xs-6 col-xs-offset-3 text-center">
          <i className="icon-smiley-down" />
          <p className="top-buffer-30">
            {I18n.tr('payouts.no_payouts')}
          </p>
        </div>
      </div>
    );
  }

  renderPayouts(payoutList: PayoutList): Object {
    // -- View
    return (
      <div className="payment_payins__data">
        <PayoutsTableView
          payouts={payoutList.payouts}
          currencyCode={this.props.currencyCode}
        />
      </div>
    );
  }

  render(): Object {
    const payoutList: PayoutList = this.props.payoutList;

    let contentView = (null);
    if (!_.isEmpty(payoutList.payouts)) {
      contentView = this.renderPayouts(payoutList);
    } else {
      contentView = this.renderNoData();
    }

    return (
      <div className="payment_payins">
        {contentView}
      </div>
    );
  }

}
